import FJViewConstant from "../../constant/FJViewConstant";

const initState = {
  filterType: 'none',
  intensity: 0,
  filterActive: true,
  adjustActive: true,
  exposure: 0,
  brightness: 0,
  temperature: 0,
  tint: 0,
  saturation: 0,
  contrast: 0,
  highlights: 0,
  shadows: 0,
  vignette: 0,
  disableAdjusts: [],
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJViewConstant.SET_ADJUST_DISABLED:
      return {
        ...state,
        disableAdjusts: action.disableAdjusts
      };
    case FJViewConstant.SET_FILTER_ACTIVE:
      return {
        ...state,
        filterActive: action.active,
      }
    case FJViewConstant.SET_FILTER_INTENSITY:
      return {
        ...state,
        intensity: action.intensity,
      }
    case FJViewConstant.SET_FILTER_TYPE:
      return {
        ...state,
        filterType: action.filterType,
      }
    case FJViewConstant.SET_ADJUST_ACTIVE:
      return {
        ...state,
        adjustActive: action.active,
      }
    case FJViewConstant.SET_ADJUST_DATA:
      return {
        ...state,
        ...action.adjustData,
      }
    default:
      return state;
  }
}